/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var useGlobalEvent = require('./useGlobalEvent.js');

var useWindowScroll = function useWindowScroll(handler) {
  return useGlobalEvent.default('scroll', null, handler);
};

exports.default = useWindowScroll;
